export default __webpack_public_path__ + "static/media/anju.e422f0d1.mp4";